import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-help",
  "use": "icon-s-help-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-help\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m1 12v2h-2v-2zm-1.06-8c1.582 0 2.954 1.022 2.954 2.8 0 .7-.294 1.232-.686 1.75l-1.036 1.372c-.14.182-.252.476-.252.714v.294H10.1v-.42c0-.602.168-.98.532-1.456l1.036-1.33c.224-.294.406-.63.406-.938 0-.658-.434-1.148-1.134-1.148-.742 0-1.12.518-1.12 1.162H8C8 7.064 9.316 6 10.94 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol